import * as React from 'react'

const Logo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="89"
    height="32"
    viewBox="0 0 89 32"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.9685 9.16508C84.5 9.16508 88.8269 13.7068 88.8269 20.5615C88.8269 27.4161 84.5 32 77.9685 32C71.1869 32 66.6521 27.4161 66.6521 20.5615C66.6521 13.7068 71.1869 9.16508 77.9685 9.16508ZM43.1087 9.62509V31.5399L38.2264 30.5361V10.587L43.1087 9.62509ZM62.6581 9.11606V14.2592L59.8447 14.7806C57.4273 15.2448 55.8727 16.5023 55.8727 19.285V31.5399L50.9904 30.5361V18.5384C50.9904 12.5838 54.4774 10.8125 59.8447 9.57615L62.6581 9.11606ZM10.7744 9.16508C12.6904 9.16508 15.04 10.2366 16.3647 12.1567C17.6944 10.4081 19.9172 9.26074 22.6452 9.2235C26.079 9.17669 30.3447 11.3398 30.3447 17.8223V31.5399L25.4624 30.5361V17.8223C25.4624 15.6475 23.8902 14.1 21.5732 14.1C19.2561 14.1 17.6839 15.6475 17.6839 17.8223V31.5399L12.8017 30.5361V17.8223C12.8017 15.6475 11.2295 14.1 8.91255 14.1C6.55409 14.1 4.98187 15.6475 4.98187 17.8223V31.5399L0.0996094 30.5361V10.587L4.98187 9.62509V11.8835C6.34721 10.2106 8.41603 9.16508 10.7744 9.16508ZM77.9685 13.7909C74.1822 13.7909 71.6445 16.4823 71.6445 20.5615C71.6445 24.6407 74.1822 27.3741 77.9685 27.3741C81.5041 27.3741 83.834 24.6407 83.834 20.5615C83.834 16.4823 81.5041 13.7909 77.9685 13.7909ZM40.7712 0C42.5477 0 43.7244 1.23521 43.7244 3.09959C43.7244 4.96387 42.5477 6.21058 40.7712 6.21058C38.9267 6.21058 37.6935 4.96387 37.6935 3.09959C37.6935 1.23521 38.9267 0 40.7712 0Z"
      fill="#050038"
    />
  </svg>
)

export default Logo
